import { useState, useEffect } from 'react'
import LocationService from 'service/LocationService'
import { ICountryList, IDistrictList, ICityList } from 'types/LocationType'

export default function useGetLocationFilterLists(countryId?: number, cityId?: number) {
  const [countryList, setCountryList] = useState<ICountryList[] | undefined>()
  const [cityList, setCityList] = useState<ICityList[] | undefined>()
  const [districtList, setDistrictList] = useState<IDistrictList[] | undefined>()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  function getCountryList() {
    setIsLoading(true)
    LocationService.getCountryList()
      .then((r) => setCountryList(r.data))
      .catch((err) => setError(true))
      .finally(() => setIsLoading(false))
  }

  function getCityList() {
    if (!!countryId) {
      LocationService.getCityList(countryId)
        .then((r) => setCityList(r.data))
        .catch((err) => setError(true))
    }
  }

  function getDistrictList() {
    if (!!cityId) {
      LocationService.getDistrictList(cityId)
        .then((r) => setDistrictList(r.data))
        .catch((err) => setError(true))
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => getCountryList(), [])

  useEffect(() => {
    getCityList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryId])

  useEffect(() => {
    getDistrictList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityId])

  return { countryList, cityList, districtList, isLoading, error }
}
